import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard'; // Import the ProductCard component
import ProductFormModal from './ProductFormModal'; // Import the modal component
import Loader from '../../../components/helpers/Loader'; // Import the Loader component
import axios from 'axios';
import './ProductDashboard.css'

function ProductDashboard() {
  const [products, setProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_SERVER_URL;
  const token = localStorage.getItem('token');

  // Function to handle product updates
  const handleEditProduct = async (updatedProduct) => {
    try {
      const response = await axios.put(
        `${apiUrl}/api/product/edit-product/${updatedProduct.id}`,
        {
          name: updatedProduct.name,
          price: updatedProduct.price,
          description: updatedProduct.description,
          features: updatedProduct.features,
          isPopular: updatedProduct.isPopular,
          annualPrice: updatedProduct.annualPrice
        },
        // {
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'Authorization': `Bearer ${token}`
        //   }
        // }
      );

      if (response.status === 200) {
        // Fetch fresh data from server instead of updating locally
        await fetchProducts();
        return response.data; // Return updated product data
      } else {
        throw new Error(response.data.message || 'Failed to update product');
      }
    } catch (error) {
      console.error('Error updating product:', error);
      throw error; // Re-throw the error to be handled by the component
    }
  };

  // Function to handle product deletion
  const handleDeleteProduct = async (productId) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/api/product/delete-product/${productId}`,
        // {
        //   headers: {
        //     'Authorization': `Bearer ${token}`
        //   }
        // }
      );

      if (response.status === 200) {
        // Remove the deleted product from the state for immediate UI update(MySQL)
        // setProducts(products.filter(product => product.id !== productId));
        setProducts(products.filter(product => product._id !== productId));    // Adjusted for MongoDB _id
        return true;
      } else {
        throw new Error(response.data.message || 'Failed to delete product');
      }
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  };
  // Function to fetch products from the backend
  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/api/product/get-products`, {
        // headers: {
        //   'Content-Type': 'application/json',
        //   'Authorization': `Bearer ${token}` // This is where your token goes
        // }
      });

      console.log(response, "response--productget")
      if (response.statusText === 'OK') {
        const data = await response?.data;
        console.log(data, "data---?")
        setProducts(data);
      } else {
        throw new Error('Failed to fetch products');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch products when the component mounts
  useEffect(() => {
    fetchProducts();
  }, []);

  // Function to handle form submission (add/update)
  const handleFormSubmit = async (productData) => {
    try {
      // Axios automatically serializes data to JSON and sets the Content-Type header
      const response = await axios.post(`${apiUrl}/api/admin/create-product`, productData,
        {
          // headers: {
          //   'Content-Type': 'application/json',
          //   'Authorization': `Bearer ${token}` // This is where your token goes
          // }
        });
      console.log(response, "response-->")
      // Axios throws an error for non-2xx status codes, so you don't need `!response.ok`
      setIsModalOpen(false); // Close modal on success
      fetchProducts(); // Refresh the list
    } catch (error) {
      // Access the response data from the error object
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Server Error:', error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Request Error:', error.message);
      }
    }
  };

  return (
    <div className="product-dashboard-container">
      <header className="dashboard-header">
        <h1>Product Plans</h1>
        <button className="add-product-btn" onClick={() => setIsModalOpen(true)}>
          + Add New Product
        </button>
      </header>

      {isLoading ? (
        <div className="loading-container">
          <Loader size={50} color="#3498db" />
          <p className="loading-text">Loading products...</p>
        </div>
      ) : (
        <div className="product-grid">
          {products.length > 0 ? (
            products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onEdit={handleEditProduct}
                onDelete={handleDeleteProduct}
              />
            ))
          ) : (
            <p className="no-products-text">No products found. Add a new one!</p>
          )}
        </div>
      )}

      {isModalOpen && (
        <ProductFormModal
          onSubmit={handleFormSubmit}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
}

export default ProductDashboard;